<ui-modal
  class="vega-by-bucket-modal"
  [isOpened]="isModalOpened"
  modalTitle="Vega by Bucket"
  (isOpenedChange)="modalChanged($event)"
>
  <div class="body">
    <div class="main-margin selectors-container" [formGroup]="vegaByBucketForm">
      <label>
        Currency Pair
        <div class="selector-container">
          <app-selector
            class="currency-pair"
            [passedItems]="activeCurrencyPairs"
            formControlName="currencyPair"
          ></app-selector>
        </div>
      </label>

      <label>
        Currency
        <div class="selector-container">
          <app-selector
            class="currency"
            [passedItems]="
              currencyPairSelected
                ? [
                    currencyPairSelected | slice: 0:3,
                    currencyPairSelected | slice: 3:6
                  ]
                : []
            "
            formControlName="currency"
          ></app-selector>
        </div>
      </label>
    </div>

    <div class="main-margin table-container">
      <table ui-table id="table-data">
        <thead>
          <tr>
            <th>Bucket</th>
            <th>Vega ({{ currencySelected }})</th>
          </tr>
        </thead>
        <tbody>
          <div class="spinner-container" *ngIf="fetchingResponse">
            <loading-spinner></loading-spinner>
          </div>

          <div class="message-container" *ngIf="errorMessage">
            {{ errorMessage }}
          </div>

          <div
            class="message-container"
            *ngIf="
              activeCurrencyPairs.length > 0 &&
              (!currencySelected || !currencyPairSelected) &&
              !fetchingResponse &&
              !errorMessage
            "
          >
            A currency pair and a currency must be selected
          </div>

          <div
            class="message-container"
            *ngIf="
              legComponents.length === 0 && !fetchingResponse && !errorMessage
            "
          >
            Create or load a leg
          </div>
          <div
            class="message-container"
            *ngIf="
              legComponents.length > 0 &&
              activeCurrencyPairs.length === 0 &&
              !fetchingResponse &&
              !errorMessage
            "
          >
            None of the legs have a currency Pair available
          </div>
          <tr
            *ngFor="
              let item of vegaByBucketResponse &&
              currencyPairSelected &&
              currencySelected
                ? vegaByBucketResponse.orderedTenors
                : [];
              index as i
            "
          >
            <td>{{ item }}</td>
            <td>
              {{
                vegaByBucketResponse.vegaByBucketByCurrency[currencySelected][
                  item
                ] | number: '1.0-0'
              }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
  <hr class="hard-return" />
  <div class="modal-footer">
    <button type="button" class="ui-button" (click)="modalChanged(false)">
      Cancel
    </button>

    <button
      type="button"
      class="ui-button primary"
      (click)="onCopyToClipboardClicked()"
    >
      Copy to Clipboard
    </button>
  </div>
</ui-modal>
